import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation  } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import { GenerateWalletTxnId, GenerateOnlineTxnId } from '../../components/GenerateThink5whysCode';

const EBSuccess = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();
  const navigate = useNavigate();
  const location = useLocation();
  const [customerId, setCustomerId] = useState(authState.user._id); 
  const [customerCode, setCustomerCode] = useState(authState.user.think5whyscode); 
  const [customerName, setCustomerName] = useState(authState.user.name); 
  const [customerEmail, setCustomerEmail] = useState(authState.user.email); 
  const [customerPhone, setCustomerPhone] = useState(''); 

  const { title, paymentAmount, gifterId, gifterName, giftFor, giftMessage, gifterSignatureLine } = location.state || {};
  const [amount, setAmount] = useState(paymentAmount ? paymentAmount: 100); 
  const [topupTitle, setTopupTitle] = useState(title ? title: 'Book'); 

  const [paymentClicked, setPaymentClicked] = useState(false);
  const [onlinePaymentClicked, setOnlinePaymentClicked] = useState(false);
  const [pgResponseData, setPgResponseData] = useState(null);
  const [pgStatus, setPgStatus] = useState(false);
  const [modePayment, setModePayment] = useState('Online');
  const [walletTransactionId, setWalletTransactionId] = useState('');
  const [transactionId, setTransactionId] = useState(GenerateOnlineTxnId());
  const [transactionDate] = useState(new Date());
  const [transactionStatus, setTransactionStatus] = useState('Initiating');
  const [paymentDetails, setPaymentDetails] = useState('');
  const [details, setDetails] = useState('Payment');
  
  const [paymentUInitiationStatus, setPaymentUInitiationStatus] = useState(false);


  const handleCheckWallet = () => {
    navigate('/wallet-mywallet');
  };

  return (
    <MainLayout>
      <div className="bg-gray-600 text-center py-8 px-4">
        <h2 className="text-3xl font-semibold mb-4 text-yellow-200">Online Payment Successful!!!</h2>
        <div className="bg-gray-800 rounded-lg shadow-md p-6 mx-auto max-w-lg">
          <button
            onClick={handleCheckWallet}
            className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
          >
            Check Think5Whys Purse / Wallet 
          </button>
        </div>
      </div>
    </MainLayout>

  );
};

export default EBSuccess;
